<template>
  <div>
    <byted-popup
      v-if="hasMessage"
      :value="showHint"
      :close-on-click-overlay="true"
      position="bottom"
      get-container="body"
      @click-overlay="showHint=false"
    >
      <byted-header class="popup-header">
        <template slot="left">
          <div />
        </template>
        <template slot="right">
          <byted-close
            theme="outline"
            fill="#333"
            size="16"
            @click="showHint=false"
            class="hint-close"
          />
        </template>
      </byted-header>
      <div class="hint-content" v-html="$t(informationText)">
      </div>
    </byted-popup>
    <div
      :class="`mobile-lite-form-header`"
    >
      {{$t(i18nKey)}}
    </div>
    <div :class="`mobile-lite-form-header_icon`"><i class="vi-icon-question" v-if="hasMessage" @click="showHint=true"/></div>

  </div>
</template>
<script>
import { defineComponent, ref } from '@vue/composition-api';

const name = 'mobile-lite-form-header';
export default defineComponent({
  name,
  props: {
    hasMessage: { type: Boolean, required: false, default: false },
    i18nKey: { type: String, required: true },
    informationText: { type: String, required: false, default: '' }
  },
  setup() {
    const showHint = ref(false);
    return {
      showHint
    };
  }
});
</script>
<style lang="scss" scope>
.hint-close{
  position: relative;
  top: -10px !important;
}
.hint-content {
  font-size: 16px !important;
  color: #121212 !important;
  margin: 16px 16px 24px;
}
.mobile-lite-form-header {
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  text-align: left;
  color: #121212;
  flex: none;
  order: 0;
  flex-grow: 0;
  margin-bottom: 8px;
  padding-right: 4px;
  display: inline-block;
  &_icon {
    display: inline-block;
    top: 1px;
    position: relative;
  }
}
</style>
